import React, { Component } from "react";
import ErrorPage from "./ErrorPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // Log error to Supabase
    // Use dynamic import to avoid circular dependencies
    import('../../services/errorLogger').then(({ logError }) => {
      logError(error, {
        errorType: 'react',
        componentStack: errorInfo.componentStack,
        severity: 'critical', // React errors are typically critical
      }).catch(err => {
        console.error('Failed to log error:', err);
      });
    }).catch(err => {
      console.error('Failed to import errorLogger:', err);
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorPage
          error={this.state.error}
          resetError={() => this.setState({ hasError: false })}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
